import _sfc_main from "./ProfileDropdownItem.vue2.js";
/* empty css                         */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const ProfileDropdownItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-3e9faf67"]]);
export {
  ProfileDropdownItem as default
};
//# sourceMappingURL=ProfileDropdownItem.vue.js.map
